import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '../../index'
import { userInfoTypes } from '../User/index'
import { countLetters } from '@/api/com'

export interface BaseTypes {
  lang: string;
  tokenData: {
    expiresIn: number;
    refreshToken: string;
    token: string;
  }
}

export interface LettersType {
  allNum: number;
  deleteNum: number;
  notReadNum: number;
  readNum: number;
}

export interface KfDataType {
  createDate?: string; // 创建时间
  email?: string; // 邮箱
  headImgUrl?: string; // 头像
  id?: number; // 主键编号
  isDefault?: number; // 是否为默认客服
  mobile?: string; // 手机号码
  modifyDate?: string; // 修改时间
  name?: string; // 姓名
  phone?: string; // 座机
  stageName?: string; // 艺名
  state?: number; // 状态（-1-删除 0-禁用 1-正常）
  wxQrcode?: string; // 微信二维码地址
}

@Module({
  name: 'Base',
  dynamic: true,
  store
})
export default class Base extends VuexModule implements BaseTypes {
  scrollTop = 250 // 控制顶部导航栏是否变色 0 默认 1 变白色
  // 语言
  lang = 'zh'
  // token过期时间
  tokenTime: number | string = 0

  // 首页弹框显示
  popUpShow = true

  // token信息
  tokenData = {
    expiresIn: 0,
    refreshToken: '',
    token: ''
  }

  // 客服信息
  kfData: KfDataType = {}

  // 别的商户--资料
  clientInfo: userInfoTypes = {
    parentMchId: NaN
  }

  // 站内信数据统计
  letters: LettersType = {
    allNum: 0,
    deleteNum: 0,
    notReadNum: 0,
    readNum: 0
  }

  // 设置token
  @Mutation
  SET_TOKEN (tokenData?: {
    expiresIn: number;
    refreshToken: string;
    token: string;
  }): boolean {
    if (tokenData) {
      const t = { ...this.tokenData, ...tokenData }
      this.tokenData = t
      sessionStorage.setItem('tokenData', JSON.stringify(t))
      return false
    }
    const tokenStr = sessionStorage.getItem('tokenData')
    if (tokenStr) {
      const token = JSON.parse(tokenStr)
      this.tokenData = token
    }
    return false
  }

  // 设置登录弹框状态
  @Mutation
  SET_POP_UP (popUpShow: boolean): void {
    this.popUpShow = popUpShow
    sessionStorage.setItem('popUpShow', JSON.stringify(popUpShow))
  }

  // 设置浏览器滚动距离多少改版顶部到顶部导航栏样式
  @Mutation
  SET_SCROLL_TOP (scrollTop: number): void {
    this.scrollTop = scrollTop
  }

  // 设置token过期时间
  @Mutation
  SET_TOKEN_EXPIRES_IN (time?: number | string): void {
    if (time) {
      this.tokenTime = time
      sessionStorage.setItem('tokenTime', time.toString())
    } else {
      this.tokenTime = Number(sessionStorage.getItem('tokenTime')) || 0
    }
  }

  // 退出清除信息 清除token 及 token过期时间 及用户自己的信息
  @Mutation
  REMOVE_TOKEN (): void {
    this.tokenData = {
      expiresIn: 0,
      refreshToken: '',
      token: ''
    }
    this.tokenTime = 0
    sessionStorage.removeItem('tokenData')
    sessionStorage.removeItem('tokenTime')
  }

  // 设置其他商户资料
  @Mutation
  SET_CLIENT_INFO (info?: userInfoTypes) {
    this.clientInfo = info || {
      parentMchId: NaN
    }
  }

  // 设置 客服信息
  @Mutation
  SET_SERVICE (kfData: KfDataType) {
    this.kfData = kfData
  }

  // 设置 站内信统计数据
  @Mutation
  SET_LETTERS (letters: LettersType) {
    this.letters = letters
  }

  // 请求 站内信统计数据
  @Action({ commit: 'SET_LETTERS' })
  async API_COUNT_LETTERS () {
    const res = await countLetters()
    if (res.success) {
      return res.data
    }
  }
}

export const BaseStore = getModule(Base);
(function () {
  const popUpShow = sessionStorage.getItem('popUpShow')
  if (popUpShow) {
    BaseStore.SET_POP_UP(JSON.parse(popUpShow))
  }

  // 设置初始token，防止用户刷新
  BaseStore.SET_TOKEN()
  // 初始化token 过期时间
  BaseStore.SET_TOKEN_EXPIRES_IN()
}())
